import React from "react";
import Layout from "../components/Layout";
import {GestionRecurrente} from "../components";
const ClientesRecurrentes = () => {
  return (
    <>
      <Layout />
      <div>
        <GestionRecurrente />
      </div>
    </>
  );
};

export default ClientesRecurrentes;
